import React from "react";
import { Typography, Progress } from "antd";
import { PageLoaderWrapper } from "./styled";

const PageLoader = () => {
    return (
        <PageLoaderWrapper>
            <div className="content">
                <Typography.Text className="mb-1 font-16" strong>
                    Loading...
                </Typography.Text>
                <Progress
                    strokeColor={{ from: "#004880", to: "#ECF7FF" }}
                    percent={100}
                    status="active"
                    showInfo={false}
                    strokeWidth={16}
                    strokeLinecap="butt"
                    type="line"
                />
            </div>
        </PageLoaderWrapper>
    );
};
export { PageLoader };